/**
 * XT-G7 — session-ending latch (customer `customerAuthSync` twin).
 * While active, callers must not surface tokens / start new session work.
 */

let sessionEndingLatch = false;

export function markAdminSessionEnding(): void {
  sessionEndingLatch = true;
}

export function clearAdminSessionEndingLatch(): void {
  sessionEndingLatch = false;
}

export function isAdminSessionEndingLatchActive(): boolean {
  return sessionEndingLatch;
}
